<template>
    <div class="spread-layout" :style="{
        width: ((cardWidth*3) + (cardHMargin*2)) + 'px',
        height: ((cardHeight*3) + (cardVMargin*2)) + 'px'
    }">
        <card-slot :slug="pour" :pos="pourPos" ref="pour"/>
        <card-slot :slug="contre" :pos="contrePos" ref="contre"/>
        <card-slot :slug="vibration" :pos="vibrationPos" ref="vibration"/>
        <card-slot :slug="direction" :pos="directionPos" ref="direction"/>
        <card-slot :slug="synthese" :pos="synthesePos" ref="synthese"/>
    </div>
</template>

<script>
    import CardSlot from './CardSlot'

    export default {
        components: {CardSlot},

        data () {return {
            pour: null,
            pourPos: {top: 0, left: 0},
            contre: null,
            contrePos: {top: 0, left: 0},
            vibration: null,
            vibrationPos: {top: 0, left: 0},
            direction: null,
            directionPos: {top: 0, left: 0},
            synthese: null,
            synthesePos: {top: 0, left: 0},
            cardWidth: null,
            cardHeight: null,
            cardHMargin: null,
            cardVMargin: null
        }},

        methods: {

            reset () {

                this.pour = null;
                this.contre = null;
                this.vibration = null;
                this.direction = null;
                this.synthese = null;

            },

            setSlotsPositions (payload, cardSlotsPos) {
                
                this.cardWidth =  payload.cardWidth;
                this.cardHeight = payload.cardHeight;
                this.cardHMargin = payload.cardHMargin;
                this.cardVMargin = payload.cardVMargin;

                this.pourPos = payload.slotsPos['pour'];
                this.contrePos = payload.slotsPos['contre'];
                this.vibrationPos = payload.slotsPos['vibration'];
                this.directionPos = payload.slotsPos['direction'];
                this.synthesePos = payload.slotsPos['synthese'];

            },

            setCardSlot (targetSlug, cardSlug) {

                this[targetSlug] = cardSlug;

            },
            
        }
    }
</script>